
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/baseUI/aiImageCreatorEntryPoint/aiImageCreatorEntryPoint.scss.css.virtualfile';
        module.exports = {"aiImageCreatorEntryPoint":"_aiImageCreatorEntryPoint_zfhuv_7"};